// extracted by mini-css-extract-plugin
export default {"checkbox":"ButtonToggleTheme_checkbox__jyzcT","lightswitch":"ButtonToggleTheme_lightswitch__R8jtS"};